import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import NetworkErrorSubmission from '@/views/NetworkErrorSubmission.vue'
import DataErrorSubmission from '@/views/DataErrorSubmission.vue'
import SubmissionReceipt from '@/views/SubmissionReceipt.vue'
import TermsAndConditions from '@/views/TermsAndConditions.vue'
import FnolInputForm from '@/views/FnolInputForm.vue'
import ReviewSubmission from '@/views/ReviewSubmission.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Main',
    component: TermsAndConditions
  },
  {
    path: '/fnol-form',
    name: 'FNOL Input Form',
    props: { visible: true },
    component: FnolInputForm
  },
  {
    path: '/review',
    name: 'FNOL Review and Submission',
    props: { visible: true },
    component: ReviewSubmission
  },
  {
    path: '/network-submission-error',
    name: 'FNOL Submission Error',
    component: NetworkErrorSubmission
  },
  {
    path: '/receipt/:receiptNumber',
    name: 'Submission Receipt',
    props: { visible: true },
    component: SubmissionReceipt
  },
  {
    path: '/data-submission-error',
    name: 'Submission Data Error',
    props: { visible: true },
    component: DataErrorSubmission
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
